var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"pieChart Chart",class:{ratio_class : _vm.useData.id == 'pieChart1'|| _vm.useData.id == 'pieChart3'},attrs:{"id":_vm.useData.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }